import React, { useState, useEffect, useCallback } from "react";
import Box from "@mui/material/Box";
import SFTPSidebar from "./SFTPSidebar";
import SFTPMain from "./SFTPMain";
import "./SFTP.css"

function SFTP() {
  const [SFTPItemID, setSFTPItemID] = useState(null);
  const [SFTPName, setSFTPName] = useState("");
  const [SFTPFiles, setSFTPFiles] = useState(null);
  const [SFTPPythonCode, setSFTPPythonCode] = useState("");
  const [SFTPNodeCode, setSFTPNodeCode] = useState("");
  const [SFTPSummaryText, setSFTPSummaryText] = useState("");
  const [SFTPColumnsData, setSFTPColumnsData] = useState([]);

  const handleSelectedSFPTCategoryID = (
    selectedSFTPCategoryID, 
    selectedSFTPName, 
    selectedSFTPFiles,
    selectedSFTPPythonCode,
    selectedSFTPNodeCode,
    selectedSFTPSummary,
    selectedSFTPColumns
  ) => {
    setSFTPItemID(selectedSFTPCategoryID);
    setSFTPName(selectedSFTPName);
    setSFTPFiles(selectedSFTPFiles);
    setSFTPPythonCode(selectedSFTPPythonCode);
    setSFTPNodeCode(selectedSFTPNodeCode);
    setSFTPSummaryText(selectedSFTPSummary);
    setSFTPColumnsData(selectedSFTPColumns);
  };

  return (
    <Box className="SFTPBody" sx={(theme) => ({ background: theme.palette.ke.background })}>
    <SFTPSidebar onSelectSFTPCategoryID={handleSelectedSFPTCategoryID} />
    <SFTPMain 
      SFTPItemID={SFTPItemID} 
      SFTPName={SFTPName} 
      SFTPFiles={SFTPFiles}
      SFTPPythonCode={SFTPPythonCode}
      SFTPNodeCode={SFTPNodeCode}
      SFTPSummaryText={SFTPSummaryText}
      SFTPColumnsData={SFTPColumnsData}
    />
    </Box>
  );
}

export default SFTP;
